export function generateAndSetZlid(
  vendor: string,
  childListingId: string
): string | null {
  const prefixMap: Record<string, string> = {
    ITSO: "1017",
    TRREB: "1002",
  };

  const prefix = prefixMap[vendor];
  if (!prefix) {
    return null;
  }
  const zlid = `${prefix}${childListingId}`;

  return zlid;
}
